import * as Scrivito from "scrivito";

export const ColumnContainerWidget = Scrivito.provideWidgetClass(
  "ColumnContainerWidget",
  {
    attributes: {
      columns: ["widgetlist", { only: "ColumnWidget" }],
      alignment: ["enum", { values: ["start", "center", "end", "stretch"] }],
      options: [
        "multienum",
        {
          values: [
            "asMobileSlider",
            "pull-content-up-5",
            "pull-content-up-7",
            "pull-content-up-10",
          ],
        },
      ],
    },
    extractTextAttributes: ["columns"],
  }
);
